//Componentes generales
import React, { useReducer, useContext, useEffect } from "react";
import controlReducer from "./controlReducer";
import controlContext from "./controlContext";
import moment from "moment";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getProductsByTDocNroFor } from "../../api/product";
import { getTDocByFilter, getTDocsByUserIdAndParams,getFilesActivos, getODTByNroFor, getInfoDashboard, getTDocsByUserIdAndParamsReport } from "../../api/transactionDocuments";

//Socket
import { SocketContext } from "../socket/socket";

//Acciones
import {
    ACTUALIZAR_TDOC,
    AGREGAR_TDOC,
    MODIFICAR_FILTROS_ESTADOS,
    MODIFICAR_FILTROS_RANGO,
    INICIAR_FILTROS,
    INICIAR_FILTROS_DASHBOARDODT,
    SET_INFO_DASHBOARDODT,
    SET_TDOCS,
    MODIFICAR_FILTROS,
    SET_TDOCS_REPORTE,
    DELETE_TDOC,
    MERGE_TDOCS
} from "./controlActions";

//Estados de autorización
import { STATES, ALERTSProcedimientosProgramados, TIPPROCS, STATESProcsProgramados, ORIGENES, CHECKLISTStates } from "../../utils/states";
import { deepEqual, filtrosToString } from "../../utils/funciones";
import { getUsersInGroupV } from "../../api/user";
import authContext from "../authentication/authContex";

//Valores iniciales
export const initialState = {
    listTDoc: null,
    listTDocReporte: null,
    infoTDocs: null,
    filtrosRango: {
        fecAlt: {
            desde: new Date(moment().year(2000).startOf('year')),
            // desde: new Date(moment(new Date).subtract(20075, 'days')),
            hasta: new Date(moment(new Date())),
        },
        fechaCompletado: {
            desde: new Date(moment().year(2000).startOf('year')),
            hasta: new Date(moment(new Date())),
        },
        fecVencimientoDesde: new Date(moment(new Date).add(-20075, 'days')),
        fecVencimientoHasta: new Date(moment(new Date).add(20075, 'days')),
        fecCompletadoHasta: new Date(moment(new Date).add(20075, 'days')),
        deliveryDate: new Date(moment().year(2080).endOf('year'))
    },
    filtrosEstado: {
        state: STATES,
        statesProcedimientos: STATESProcsProgramados,
        tipoAlerta: ALERTSProcedimientosProgramados,
        tipoProcedimientos: TIPPROCS,
        statesChecklist: CHECKLISTStates,
        tipoActivos: [],
        priority: [0, 1, 2],
        userName: [],
        origenes: ORIGENES,
        activos: []
    },
    filtrosEstadoPredeterminado: null,
    cargando: true,
};

/* 
    State encargado de la gestión de filtros y listado de requerimientos. (No se encuentra tan en uso, en la mayoria fue reemplazado por controlGLB).
*/
const ControlState = props => {

    const server = useContext(SocketContext);
    
    const [state, dispatch] = useReducer(controlReducer, initialState);

    const aContext = useContext(authContext);
    const {usuario, verificarTenant} = aContext;

    //Inicializa los filtros dependiendo del usuarios 
    const iniciarFiltros = async (states = STATES, usuarioParam = "", tipoAlerta = ALERTSProcedimientosProgramados, tipoProcedimientos = TIPPROCS, componentePadre='ordenTrabajo', statesProcedimientosParam = STATESProcsProgramados, origenesParam = ORIGENES, filtrosRango = initialState.filtrosRango) => {
        try {
            //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
            const filtrosString = filtrosToString(filtrosRango);

            let userToUse = usuarioParam ? usuarioParam : usuario;

            //Obtengo los usuarios que puede ver el userToUse mediante su campo groupV
            const respUsuarios = await getUsersInGroupV(userToUse._id);
            
            //Creo un arreglo de userNames y luego si no se encuentra el userToUse en sesion lo agrego
            const usuarios = [...new Set(respUsuarios.data.data.map((u) => u.user.userName))];

            if(!usuarios.includes(userToUse.userName)) usuarios.push(userToUse.userName);

            const filtrosEstado = {
                ...initialState.filtrosEstado,
                state: (componentePadre == 'ordenTrabajo' || componentePadre == 'OPD') ? states : STATES,
                tipoAlerta: tipoAlerta,
                tipoProcedimientos: tipoProcedimientos,
                statesProcedimientos: statesProcedimientosParam,
                origenes: origenesParam,
                statesChecklist: CHECKLISTStates,
                userName: usuarios,
                tipoActivos: [],
                activos: userToUse.activosAllowed.map(a => a.value),
                ...(componentePadre == 'OPD' && { revisadaProduccion: [false, true] })
            };

            dispatch({
                type: MODIFICAR_FILTROS,
                payload: {
                    filtrosEstado: filtrosEstado,
                    filtrosRango: filtrosRango
                }
            });

            if(componentePadre == 'ordenTrabajo'){
                //Relizo peticion con los parametros de rango y el usuarioParam en secion
                const resp = await getTDocsByUserIdAndParams(userToUse._id, filtrosString);
                dispatch({
                    type: SET_TDOCS,
                    payload: {
                        cabeceraReqs: resp.data.data
                    }
                });
              
            }
            return true;
        } catch (error) {
            console.log(error);
            console.log("Error a la hora de iniciar filtros");
        }
    };
    //Inicializa los filtros dependiendo del usuarios 
    const iniciarFiltrosReporte = async (states = STATES, usuarioParam = "", tipoAlerta = ALERTSProcedimientosProgramados, tipoProcedimientos = TIPPROCS, componentePadre='ordenTrabajo', statesProcedimientosParam = STATESProcsProgramados, origenesParam = ORIGENES, filtrosRango = initialState.filtrosRango) => {
        try {
            //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
            const filtrosString = filtrosToString(initialState.filtrosRango);

            let userToUse = usuarioParam ? usuarioParam : usuario;

            //Obtengo los usuarios que puede ver el userToUse mediante su campo groupV
            const respUsuarios = await getUsersInGroupV(userToUse._id);
            
            //Creo un arreglo de userNames y luego si no se encuentra el userToUse en sesion lo agrego
            const usuarios = [...new Set(respUsuarios.data.data.map((u) => u.user.userName))];

            if(!usuarios.includes(userToUse.userName)) usuarios.push(userToUse.userName);

            const filtrosEstado = { ...initialState.filtrosEstado, state: (componentePadre == 'ordenTrabajo') ? states : STATES, tipoAlerta: tipoAlerta, tipoProcedimientos: tipoProcedimientos, statesProcedimientos: statesProcedimientosParam, origenes: origenesParam, statesChecklist: CHECKLISTStates, userName: usuarios, tipoActivos: [], activos: userToUse.activosAllowed.map(a => a.value)};

            dispatch({
                type: MODIFICAR_FILTROS,
                payload: {
                    filtrosEstado: filtrosEstado,
                    filtrosRango: filtrosRango
                }
            });

            if(componentePadre == 'ordenTrabajo'){
                //Relizo peticion con los parametros de rango y el usuarioParam en secion
                const resp = await getTDocsByUserIdAndParamsReport(userToUse._id, filtrosString);
                dispatch({
                    type: SET_TDOCS_REPORTE,
                    payload: {
                        listaRequerimientos: resp.data.data,
                    }
                });
              
            }
            return true;
        } catch (error) {
            console.log(error);
            console.log("Error a la hora de iniciar filtros");
        }
    };

    const iniciarFiltrosGetInfoODTs = async (states = STATES, usuario = "", tipoAlerta = ALERTSProcedimientosProgramados, tipoProcedimientos = TIPPROCS,  statesProcedimientosParam = STATESProcsProgramados, origenesParam = ORIGENES, filtrosRango = initialState.filtrosRango) => {
        try {
            //Relizo peticion con los parametros de rango y el usuario en secion
            // const resp = await getInfoDashboardODT(usuario._id, filtrosRango);
            
            //Obtengo los usuarios que puede ver el usuario mediante su campo groupV
            const respUsuarios = await getUsersInGroupV(usuario._id);
            
            //Creo un arreglo de userNames y luego si no se encuentra el usuario en sesion lo agrego
            const usuarios = [...new Set(respUsuarios.data.data.map((u) => u.user.userName))];
            if(!usuarios.includes(usuario.userName)) usuarios.push(usuario.userName);

            const filtrosEstado = { ...initialState.filtrosEstado, state:  states, tipoAlerta: tipoAlerta, tipoProcedimientos: tipoProcedimientos, statesProcedimientos: statesProcedimientosParam, origenes: origenesParam, statesChecklist: CHECKLISTStates, userName: usuarios, tipoActivos: [], activos: usuario.activosAllowed.map(a => a.value)};

            dispatch({
                type: INICIAR_FILTROS_DASHBOARDODT,
                payload: {
                    // infoTDocs: resp.totalizador,
                    filtrosEstado: filtrosEstado,
                    filtrosRango: filtrosRango
                }
            });
            // return resp.totalizador;
            return true;
        } catch (error) {
            console.log("Error a la hora de iniciar filtros");
            console.log(error);
        }
    }

    //Modifica los filtros de rango y trae los tDocs acorde a los parametros enviados
    const modificarFiltrosRango = async (userId , filtrosRango) => {
        const filtrosString = filtrosToString(filtrosRango);

        let areEquals = deepEqual(state.filtrosRango, filtrosRango);

        //Si se detectaron cambios en los filtros por rango, vuelven a solicitarse los documentos al backend.
        if(!areEquals){
            //Probando, esta iba despues de declarar listaRequerimientos cuando SET_TDOCS no existia.
            dispatch({
                type: MODIFICAR_FILTROS_RANGO,
                payload: { filtrosRango }
                // payload: { filtrosRango, listaRequerimientos }
            })

            const resp = await getTDocsByUserIdAndParams(userId, filtrosString);//clienteAxios.post('/transactionDocument/filter', filtrosRango);
            
            const listaRequerimientos = resp.data.data;
            
            dispatch({
                type: SET_TDOCS,
                payload: { cabeceraReqs: listaRequerimientos }
            })
        }
    };

    //Modifica los filtros de estado
    const modificarFiltrosEstado = (filtrosEstados) => {
        dispatch({
            type: MODIFICAR_FILTROS_ESTADOS,
            payload: filtrosEstados
        })
    };
    
    //Filtra una lista de tDoc de acuerdo a los filtros
    const filtrar = (lista, filtrosEstado, filtrosRango = {}, componentePadre = '') => {
        let listaFiltrada;

        if (!lista || lista === undefined || state.filtrosEstado.userName === undefined ) return undefined;

        // Caso especial para OPD
        if(componentePadre == 'OPD'){
            const truncateTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

            listaFiltrada = lista.filter((opd) => {
                // Filtro por estado
                if(filtrosEstado.state && filtrosEstado.state.length > 0 && !filtrosEstado.state.includes(opd.state)) return false;

                // Filtro por usuario
                if(filtrosEstado.userName.length > 0 && !filtrosEstado.userName.includes(opd.userName)) return false;

                // Filtro por fecha de alta
                if(filtrosRango.fecAlt?.desde){
                    const fecAltDesde = truncateTime(new Date(filtrosRango.fecAlt.desde));
                    const fecAltOpd = truncateTime(new Date(opd.fecAlt));
                    if(fecAltOpd < fecAltDesde) return false;
                }
                if(filtrosRango.fecAlt?.hasta){
                    const fecAltHasta = truncateTime(new Date(filtrosRango.fecAlt.hasta));
                    const fecAltOpd = truncateTime(new Date(opd.fecAlt));
                    if(fecAltOpd > fecAltHasta) return false;
                }

                // Filtro por fecha de entrega (solo hasta)
                if(filtrosRango.deliveryDate){
                    if(!opd.deliveryDate) return false;
                    const deliveryHasta = truncateTime(new Date(filtrosRango.deliveryDate));
                    const deliveryOpd = truncateTime(new Date(opd.deliveryDate));
                    if(deliveryOpd > deliveryHasta) return false;
                }

                // Filtro por prioridad
                if(filtrosEstado.priority && filtrosEstado.priority.length > 0 && !filtrosEstado.priority.includes(opd.priority)) return false;

                // Filtro por revisadaProduccion
                if(filtrosEstado.revisadaProduccion && filtrosEstado.revisadaProduccion.length > 0) {
                    const opdRevisada = opd.revisadaProduccion ?? false;
                    if(!filtrosEstado.revisadaProduccion.includes(opdRevisada)) return false;
                }

                // Filtro por activos (a través de tareas)
                if(filtrosEstado.activos && filtrosEstado.activos.length > 0) {
                    const activosDeOPD = [];
                    if(opd.tareas) {
                        opd.tareas.forEach(tarea => {
                            if(tarea.codActivo) activosDeOPD.push(tarea.codActivo);
                        });
                    }
                    // La OPD debe tener al menos uno de los activos filtrados
                    const tieneActivoFiltrado = filtrosEstado.activos.some(codActivo => activosDeOPD.includes(codActivo));
                    if(!tieneActivoFiltrado) return false;
                }

                // Filtro por fecha de completado (solo aplica a OPDs finalizadas)
                if(opd.state === 'FINALIZADA' && opd.fechaCompletado) {
                    const fechaCompletadoOpd = truncateTime(new Date(opd.fechaCompletado));

                    if(filtrosRango.fechaCompletado?.desde) {
                        const fechaDesde = truncateTime(new Date(filtrosRango.fechaCompletado.desde));
                        if(fechaCompletadoOpd < fechaDesde) return false;
                    }
                    if(filtrosRango.fechaCompletado?.hasta) {
                        const fechaHasta = truncateTime(new Date(filtrosRango.fechaCompletado.hasta));
                        if(fechaCompletadoOpd > fechaHasta) return false;
                    }
                }

                return true;
            });

            return listaFiltrada;
        }

        if(componentePadre != 'ProcedimientosProgramados' && componentePadre != 'Documentos' && componentePadre != 'ChecklistReg'){

            listaFiltrada = lista?.filter(item => (filtrosEstado.state.includes(item.state) && filtrosEstado.priority.includes(item.priority)) && filtrosEstado.userName.includes(item.userName) && (filtrosEstado.activos.length > 0 ? filtrosEstado.activos.includes(item.codActivo) : true) && (componentePadre != 'ReportesODT' || filtrosEstado.origenes.includes(item.originado)));

            if(componentePadre == 'Consumos'){
                let fecAltDesde = '';
                let fecAltHasta = '';
                let fecAltCk;

                const truncateTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

                if(filtrosRango.fecAlt.desde != undefined){
                    fecAltDesde = new Date(filtrosRango.fecAlt.desde);
                    fecAltDesde = truncateTime(fecAltDesde);
                }
                if(filtrosRango.fecAlt.hasta != undefined){
                    fecAltHasta = new Date(filtrosRango.fecAlt.hasta);
                    fecAltHasta = truncateTime(fecAltHasta);
                }
                
                listaFiltrada = listaFiltrada.filter((c) => {
                    
                    
                    fecAltCk = new Date(c.fecAlt);
                    fecAltCk = truncateTime(fecAltCk);
                    return (fecAltCk >= fecAltDesde && fecAltCk <= fecAltHasta && filtrosEstado.userName.includes(c.userName) && (filtrosEstado.activos.length == 0 || filtrosEstado.activos.includes(c.codActivo)) && (filtrosEstado.tipoActivos.length == 0 || filtrosEstado.tipoActivos.includes(c.tipAct)))
                })
            }
            
            return listaFiltrada

        }else{
            
            //La segunda comprobación se realiza con un OR ya que procsProgramados no incluye prioridad por lo que con que se cumpla la primera ya pasaria.
            listaFiltrada = lista.slice();                            
            
            listaFiltrada = listaFiltrada?.filter(item => (componentePadre == 'ChecklistReg' || (componentePadre == 'Documentos' && filtrosEstado.tipoAlerta.length == 2) || (filtrosEstado.tipoAlerta.includes(item.tipoAlerta))) && 
            (componentePadre == 'ProcedimientosProgramados' || componentePadre == 'Documentos' || filtrosEstado.userName.includes(item.userName)) && 
            (filtrosEstado.activos.length > 0 ? filtrosEstado.activos.includes(item.codActivo) : true ));

            if (componentePadre == 'Documentos'){
                let fecVec = '';
                let fecVecDesde;
                let fecVecHasta;
                
                const truncateTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

                if(filtrosRango.fecVencimientoDesde != undefined){
                    fecVecDesde = new Date(filtrosRango.fecVencimientoDesde);
                    fecVecDesde = truncateTime(fecVecDesde);
                }
                if(filtrosRango.fecVencimientoHasta != undefined){
                    fecVecHasta = new Date(filtrosRango.fecVencimientoHasta);
                    fecVecHasta = truncateTime(fecVecHasta);
                }
       
                listaFiltrada = listaFiltrada.filter((d) => {
                    fecVec = new Date((d.fecha != '') ? d.fecha : '1900-01-01');
                    fecVec = truncateTime(fecVec);
                    return (fecVec >= fecVecDesde && fecVec <= fecVecHasta && (filtrosEstado.activos.length == 0 || filtrosEstado.activos.includes(d.codActivo)));
                })
            }
            
            return listaFiltrada;
        }
    };

    // no en uso
    const filtroActivo = async (activos) => {
        const activo = await getFilesActivos(activos)
        const filtrosEstado = { ...initialState.filtrosEstado, activos: activo.data.data };
        return filtrosEstado
    }

    const getODTByNrofor = async (nrofor) => {
        const odt = await getODTByNroFor(nrofor);
        return odt;
    }

    //AuxiliarW
    const getProductsByNroFor = async (tDocCodFor, tDocNroFor) => {
        try {
            const resp = await getProductsByTDocNroFor(tDocCodFor ,tDocNroFor); //clienteAxios.get(`/productBytDocNroFor/${tDocCodFor}/${tDocNroFor}`);
            return resp.data.data
        } catch (error) {
            console.log(error.response);
        }
    };

    const getInfoDashboardODT = async (usuarioId, filtrosRango = "", filtrosEstado = {}) => {
        try {
            const filtrosString = filtrosToString(filtrosRango);
            const resp = await getInfoDashboard(usuarioId, filtrosString, filtrosEstado);
            dispatch({
                type: SET_INFO_DASHBOARDODT,
                payload: {
                    infoTDocs: resp.data.totalizador,
                }
            });
            return true;
        } catch (error) {
            console.log("error en getInfoDashboardODT");
            console.log(error);
            
        }
    }

    //Modifica los filtros de rango y trae los tDocs acorde a los parametros enviados
    const getAndMergeTDocsByFecAlt = async (userId , filtrosRango) => {
        const filtrosString = filtrosToString(filtrosRango);

        let areEquals = deepEqual(state.filtrosRango, filtrosRango);

        //Si se detectaron cambios en los filtros por rango, vuelven a solicitarse los documentos al backend.
        if(!areEquals){
            const resp = await getTDocsByUserIdAndParams(userId, filtrosString);//clienteAxios.post('/transactionDocument/filter', filtrosRango);
            dispatch({
                type: MERGE_TDOCS,
                payload: { tDocsToMerge: resp.data.data.filter(o => !(state.listTDoc.some(ot => o._id == ot._id))) }
            })
        }
    };

    // Se saco el iniciarFiltros() global de aca: este efecto corre en TODA la app (ControlState
    // envuelve toda la app) cada vez que "usuario" cambia, y al llamarse sin argumentos usaba
    // los defaults de iniciarFiltros (STATES completo + rango 2000-hoy), pisando la inicializacion
    // propia y acotada que ya hace cada vista (p.ej. Home) en su propio mount. Cada vista que
    // necesita esto ya llama iniciarFiltros con sus propios parametros.

    /* 
        Disparadores que sincronizan la lista de requerimientos ante la creación de un requerimiento.
    */
    useEffect(() => {
        if(server){
            //TDoc Nuevo
            server.on('addTDoc', ({tenantId,tDocCreated}) => {
                const update = verificarTenant(tenantId);
                if(update){
                    console.log("Recibo el evento del Real Time Server addTDoc");
                    if(tDocCreated.tDocCodFor == 'ODT'){
                        dispatch({
                            type: AGREGAR_TDOC,
                            payload: tDocCreated
                        })
                    }
                }
            });
            return () => server.off('addTDoc');
        }
    }, [server]);
   
    /* 
        Disparadores que sincronizan la lista de requerimientos ante la creación de un requerimiento.
    */
    useEffect(() => {
        if(server){
            //TDoc Nuevo
            server.on('deleteTDoc', ({id, tenantId}) => {
                console.log("Recibo el evento del Real Time Server deleteTDoc");
                const update = verificarTenant(tenantId);
                if(update){
                    dispatch({
                        type: DELETE_TDOC,
                        payload: id
                    })
                }
            });
            return () => server.off('deleteTDoc');
        }
    }, [server]);

    /* 
        Disparadores que sincronizan la lista de requerimientos ante la modificación de un requerimiento.
    */
    useEffect(() => {
        if(server){
            //TDoc Modificado
            server.on('modTDoc', ({ tDoc, tenantId }) => {
                const update = verificarTenant(tenantId);
                if(update){
                    dispatch({
                        type: ACTUALIZAR_TDOC,
                        payload: tDoc
                    })
                }
            });
            return () => server.off('modTDoc');
        }
    },[server])

    return (
        <controlContext.Provider
            value={{
                listTDoc: state.listTDoc,
                listTDocReporte: state.listTDocReporte,
                cargando: state.cargando,
                infoTDocs: state.infoTDocs,
                filtrosRango: state.filtrosRango,
                filtrosEstado: state.filtrosEstado,
                initialState: initialState,
                filtrar,
                iniciarFiltros,
                iniciarFiltrosReporte,
                getODTByNrofor,
                getInfoDashboardODT,
                getProductsByNroFor,
                modificarFiltrosRango,
                modificarFiltrosEstado,
                iniciarFiltrosGetInfoODTs,
                getAndMergeTDocsByFecAlt
            }}
        >
            {props.children}
        </controlContext.Provider>
    )
}

export default ControlState;